var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.14 22.372l7.083-20.618C22.55.794 21.6-.207 20.69.137L1.14 7.607C.393 7.885.244 8.903.836 9.527l3.834 4.06c.417.439 1.057.52 1.489.17l12.358-9.712L9.303 17.07c-.323.464-.248 1.14.17 1.579l3.849 4.043c.591.624 1.557.468 1.819-.319z"
  })));
}

export default SvgSend;